import { useCallback, useState } from "react"
import { GetApp } from "../../App"
import { BlockField } from "../../Components/Block"
import { PredefinedSelect } from "../../Components/PredefinedSelect"
import { ShipSingleRowDataItem } from "../../Components/ShipSingleRowDataItem"
import { IShipDataDevice } from "../../Types"
import { GetShipData } from "./Context"

interface ShipDataDeviceViewProps {
  data: IShipDataDevice;
  editable: boolean;
  index: number;
  onEdited?: () => void;
  removeDevice: () => void;
  devices: string;
}

export function ShipDataDeviceView({ data, editable, index, onEdited, removeDevice, devices }: ShipDataDeviceViewProps) {
  const app = GetApp();
  const t = app.getT("ShipDataView");
  const namePrefix = `devices.${devices}[${index}].`;
  const _state = GetShipData();

  const [deviceType, setDeviceType] = useState<string | undefined>(data.deviceType);
  const predefinedTypes = {
    "nautical": ["analogue_compass", "gyro_compass", "fluxgate_compass", "satellite_compass", "chart_plotter", "gps", "ais", "radio", "antenna", "radar", "wind_gauge", "autopilot", "display_instruments", "fuel_gauge", "battery_controller", "hour_meter", "tachometer", "logger", "sounder", "air_temperature", "barometer", "humidity", "weather_receiver", "nmea_gateway", "nmea_motor_adapter"].toSorted(),

    "electric": ["battery", "inverter", "charger", "wind_generator", "solar_panel"].toSorted(),

    "safety": ["fire_extinguisher", "liferaft", "lifejacket", "lifebelt", "lifeline", "spare_propeller", "emergency_tiller", "bilge_pump_manual", "bilge_pump_electric", "shroud_cutter", "radar_reflector", "first_aid", "fire_blanket", "dinghy", "dinghy_motor", "handheld_radio", "epirb"].toSorted(),
  }[devices] || [];

  const selectDeviceType = useCallback((value?: string) => {
    setDeviceType(value);
    if (onEdited) {
      onEdited();
    }
  }, []);

  return (
    <ShipSingleRowDataItem namePrefix={namePrefix} id={data.id} rowClassName="device-fields-row" onRemove={removeDevice}>
      <BlockField label={t("device")} className="block_field_small_16">
        <PredefinedSelect value={deviceType} predefined={predefinedTypes} label={(v) => t(`device_${devices}_${v}`)} customValue={t("other")} name={`${namePrefix}deviceType`} onSelect={selectDeviceType} readOnly={!editable} sort />
      </BlockField>
      <BlockField label={t("manufacturer")} className="block_field_small_18">
        <input name={`${namePrefix}manufacturer`} onChange={onEdited} defaultValue={data.manufacturer} readOnly={!editable} />
      </BlockField>
      <BlockField label={t("model")} className="block_field_small_18">
        <input name={`${namePrefix}model`} onChange={onEdited} defaultValue={data.model} readOnly={!editable} />
      </BlockField>
      <BlockField label={t("serial_number")} className="block_field_small_18">
        <input name={`${namePrefix}serialNumber`} onChange={onEdited} defaultValue={data.serialNumber} readOnly={!editable} />
      </BlockField>
      <BlockField label={t("date_installation")} className="block_field_small_12">
        <input name={`${namePrefix}dateInstallation`} onChange={onEdited} defaultValue={data.dateInstallation} readOnly={!editable} />
      </BlockField>
      <BlockField label={t("place_installation")} className="block_field_small_22">
        <input name={`${namePrefix}placeInstallation`} onChange={onEdited} defaultValue={data.placeInstallation} readOnly={!editable} />
      </BlockField>
      <BlockField label={t("special_features")} className="block_field_small_20">
        <input name={`${namePrefix}specialFeatures`} onChange={onEdited} defaultValue={data.specialFeatures} readOnly={!editable} />
      </BlockField>
    </ShipSingleRowDataItem>
  );
}
